<template>
  <span ref="backToTop" tabindex="-1" class="sr-only"></span>
  <ul class="skip-links">
    <li>
      <a href="#main" class="skip-link">{{ $t('skip_link') }}</a>
    </li>
  </ul>

  <HtmlHead>
    <html lang="de" />
  </HtmlHead>

  <component :is="layout" :data-page="pageCssClass">
    <router-view />
  </component>

  <SignInWithWkisWarningPopup v-if="showSigninWkisWarningModal" />
</template>

<script>
import { Head } from '@vueuse/head'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import OnboardingLayout from '@/layouts/OnboardingLayout.vue'
import SignInWithWkisWarningPopup from '@/components/SignInWithWkisWarningPopup/index.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    DefaultLayout,
    OnboardingLayout,
    HtmlHead: Head,
    SignInWithWkisWarningPopup,
  },

  computed: {
    layout() {
      return this.$route.meta.layout || 'default-layout'
    },

    pageCssClass() {
      return this.$route.name
    },

    ...mapGetters('wkis', ['showSigninWkisWarningModal']),
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.backToTop) {
            this.$refs.backToTop.focus()
          }
        })
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.skip-links {
  padding: 0;
  margin: 0;
  list-style: none;
}

.skip-link {
  position: fixed;
  top: 0;
  left: 50%;
  margin: 1em auto;
  margin-left: -72px;
  opacity: 0;
  white-space: nowrap;

  &:focus {
    padding: 0.5em;
    border: 1px solid black;
    background-color: white;
    opacity: 1;
  }
}

.sr-only {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border-width: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}
</style>
